/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        // detect if android or ios
        function getMobileOperatingSystem() {
          var userAgent = navigator.userAgent || navigator.vendor || window.opera;
          // Windows Phone must come first because its UA also contains "Android"
          if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
          }
          if (/android/i.test(userAgent)) {
            return "Android";
          }
          // iOS detection from: http://stackoverflow.com/a/9039885/177710
          if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
          }
          return "unknown";
        }

        var mos = getMobileOperatingSystem();
        console.log(mos);
        if (mos === 'Android') {
          //$('.top-menu .signup, .top-menu .login').attr('href','https://play.google.com/store/apps/details?id=com.fdna.face2gene&hl=en');
        }
        else if (mos === 'iOS') {
          //$('.top-menu .signup, .top-menu .login').attr('href','https://itunes.apple.com/us/app/face2gene/id533737939?mt=8');
        }

      },
      finalize: function() {
        // get browser device


        // JavaScript to be fired on all pages, after page specific JS is fired
        $('#client-carousel').flexslider({
          animation: "slide",
          slideshowSpeed: 4500,
          animationLoop: true,
          controlNav: false,
          itemWidth: 143,
          itemMargin: 5,
          move: 1
        });

        $('#cadd-slider').flexslider({
          animation: "fade",
          slideshow: true,
          controlNav: false,
          directionNav: false,
          slideshowSpeed: 4000,
          animationSpeed: 400,
        });
        if( $('.page-bottom').css('display')!=='none') {
          $('#testimonials').flexslider({
            animation: "slide",
            slideshowSpeed: 5000,
            animationLoop: true,
            controlNav: false,
            itemWidth: 380,
            minItems: 3,
            itemMargin: 40,
            move: 1
          });
        }

        if( $('.page-bottom').css('display')!=='none') {
          $('#panel-carousel').flexslider({
            animation: "slide",
            slideshowSpeed: 3000,
            controlNav: false,
            itemWidth: 150,
            minItems: 3,
            maxItems: 5,
            itemMargin: 20,
            move: 1
          });
        }

        /* Intercom Acquire embed script */
          window.intercomSettings = {
              app_id: 'v5y4xlhi'
          };
          (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function")    {ic('reattach_activator');ic('update',intercomSettings);}else{var    d=document;var i=function(){i.c(arguments)};i.q=[];i.c=function(args)   {i.q.push(args)};w.Intercom=i;function l(){var   s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/v5y4xlhi';var x=d.getElementsByTagName('script')   [0];x.parentNode.insertBefore(s,x);}if(w.attachEvent)   {w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})()


          // outbound link add tracking code
          $('a.outbound').click(function(event) {
              //event.preventDefault();
              console.log('this: '+event.target.href);
              ga('send', 'event', {
                  eventCategory: 'Outbound Link',
                  eventAction: 'click',
                  eventLabel: event.target.href,
                  transport: 'beacon'
              });
          });


          //$('a.mlink').colorbox({inline:true, width:650, height:300});
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        // load flexslider for home page banner
        var imgtmp;
        $('.home-banner.flexslider li span').each(function() {
          imgtmp = $(this).find('img').attr('src');
          $(this).css('background-image','url('+imgtmp+')');
        });
        $('.home-banner.flexslider').flexslider({
          controlNav: false,
          directionNav: true,
          slideshowSpeed: 4500,
          animation: 'fade',
          pauseOnHover: true,
        });

        // mobile search activate
        $('.site-search').click(function() {
          $(this).addClass('active');
        });
        $('#home-slider > .slide-container').flexslider({
          animation: "fade",
          slideshowSpeed: 4500,
          animationSpeed: 600,
          manualControls: ".slider-control-nav li",
          init: function(slider) {
            var firstSlide = slider.find("li.flex-active-slide");
            $('#home-slider').addClass($(firstSlide).attr('class'));
          },
          after: function(slider) {
            console.log(slider.currentSlide);
            var curSlide = slider.find("li.flex-active-slide");
            $('#home-slider').removeClass().addClass($(curSlide).attr('class'));
          }
        });

      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


